import { Form } from 'react-bootstrap';
import { Controller, FieldError, useFormContext } from 'react-hook-form';

export interface ISelectItem {
    value: any;
    title: string;
}

export type HookCheckFormControlProps = {
    name: any;
    label?: string;
    rules?: any;
    defaultValue?: any;
    [key: string]: any;
};

const HookCheckFormControl = (props: HookCheckFormControlProps) => {
    const { name = ``, label = ``, defaultValue = ``, rules = {}, ...rest } = props;
    const form = useFormContext();

    return (
        <>
            <Controller
                name={name}
                render={({ field }) => (
                    <Form.Check
                        type="checkbox"
                        {...field}
                        {...rest}
                        isInvalid={!!form.formState.errors[name]}
                        onChange={(value) => {
                            field.onChange(value);
                            if (props.onChange) {
                                props.onChange(value);
                            }
                        }}
                        style={{ display: 'inline-block' }}
                        checked={field.value}
                    ></Form.Check>
                )}
                control={form.control}
                defaultValue={defaultValue}
                rules={rules}
            />
            <Form.Label style={{ position: 'relative', top: '-8px' }}>
                {label}
                {rules?.required && <span className="required-mark" />}
            </Form.Label>
            <Form.Control.Feedback type="invalid">
                {(form.formState.errors[name] as FieldError)?.message}
            </Form.Control.Feedback>
        </>
    );
};

export default HookCheckFormControl;
